import queryString from 'query-string-es5'
import { getCookie, setCookie } from './cookies'

function setTrackingCookies(location) {
    if (typeof window === 'undefined') {
        return
    }
    const {
        pub,
        keyword,
        device,
        referrer,
        utm_campaign,
        gclid,
        utm_term,
        target,
        creative,
        net,
        mt,
        loc,
        source,
    } = queryString.parse(location.search)

    if (gclid) {
        setCookie('gclid', gclid)
    }
    if (referrer) {
        setCookie('referrer', referrer)
    } else if (document.referrer !== '') {
        setCookie('referrer', document.referrer)
    }
    if (pub) {
        // Google, Bing
        setCookie('campaignID', pub)
    } else if (utm_campaign) {
        // Facebook
        setCookie('campaignID', utm_campaign)
    }
    if (device) {
        setCookie('device', device)
    }
    if (keyword) {
        setCookie('keyword', keyword)
    } else if (utm_term) {
        setCookie('keyword', utm_term)
    }
    if (target) {
        setCookie('target', target)
    }
    if (creative) {
        setCookie('creative', creative)
    }
    if (net) {
        setCookie('net', net)
    }
    if (mt) {
        setCookie('mt', mt)
    }
    if (loc) {
        setCookie('loc', loc)
    }
    if (source) {
        setCookie('adSource', source)
    }
    if (getCookie('userJourney') === '') {
        const expiresIn2Days = new Date(
            new Date().getTime() + 1000 * 60 * 60 * 24 * 2,
        ).toGMTString()
        setCookie('userJourney', location.pathname, expiresIn2Days)
    }
}

function getTrackingCookies() {
    return {
        gclid: getCookie('gclid'),
        referrer: getCookie('referrer'),
        campaignID: getCookie('campaignID'),
        device: getCookie('device'),
        keyword: getCookie('keyword'),
        target: getCookie('target'),
        creative: getCookie('creative'),
        net: getCookie('net'),
        mt: getCookie('mt'),
        loc: getCookie('loc'),
        adSource: getCookie('adSource'),
        userJourney: getCookie('userJourney'),
    }
}

export { setTrackingCookies, getTrackingCookies }
